import { UpgradePreviewStatus } from "./UpgradePreviewStatus";

export const UpgradeAcceptedStatus = ({
  isProcessing,
  targetTrialDays,
}: {
  isProcessing: boolean;
  targetTrialDays?: number;
}) => {
  if (!isProcessing) return null;

  return <UpgradePreviewStatus isLoading targetTrialDays={targetTrialDays} />;
};
